import React, { useState } from 'react';
import { Container, Table, Row, Col, Badge, Button } from 'react-bootstrap';

const UPICollect = () => {
  // Mock data for UPI Collect requests
  const [data] = useState([
    {
      transactionDate: '2024-01-15',
      name: 'Rajesh Kumar',
      utr: 'UTR202401150001',
      upiHandle: 'rajesh@paytm',
      amount: 5000,
      status: 'Success'
    },
    {
      transactionDate: '2024-01-16',
      name: 'Amit Sharma',
      utr: 'UTR202401160002',
      upiHandle: 'amit.sharma@okaxis',
      amount: 2500,
      status: 'Pending'
    },
    {
      transactionDate: '2024-01-17',
      name: 'Priya Singh',
      utr: 'UTR202401170003',
      upiHandle: 'priya@ybl',
      amount: 7500,
      status: 'Success'
    },
    {
      transactionDate: '2024-01-18',
      name: 'Suresh Patel',
      utr: 'UTR202401180004',
      upiHandle: 'suresh@paytm',
      amount: 1200,
      status: 'Failed'
    },
    {
      transactionDate: '2024-01-19',
      name: 'Neha Verma',
      utr: 'UTR202401190005',
      upiHandle: 'neha.verma@okicici',
      amount: 3500,
      status: 'Success'
    }
  ]);

  // Retailer info (you can get this from context/API)
  const retailerInfo = {
    agentName: 'Webdekho Technologies Pvt Ltd India',
    contact: '9876******',
    upiId: 'branchx@paytm'
  };

  // Column definitions
  const columns = [
    { key: 'transactionDate', label: 'Date' },
    { key: 'name', label: 'Name' },
    { key: 'utr', label: 'UTR' },
    { key: 'upiHandle', label: 'UPI Handle' },
    { key: 'amount', label: 'Amount' },
    { key: 'status', label: 'Status' }
  ];

  // Handle download QR code
  const handleDownloadQR = () => {
    // TODO: Implement QR code download functionality
    alert('QR Code downloaded successfully');
  };

  // Get status badge variant
  const getStatusVariant = (status) => {
    switch(status) {
      case 'Success': return 'success';
      case 'Pending': return 'warning';
      case 'Failed': return 'danger';
      default: return 'secondary';
    }
  };

  return (
    <Container fluid className="p-4">
      <div className="user-table-container">
        {/* Header with Title */}
        <Row className="mb-4">
          <Col>
            <h4 className="mb-0" style={{ color: '#1e293b', fontWeight: '700', fontSize: '1.5rem' }}>
              <i className="bi bi-credit-card-2-back me-2"></i>
              UPI Collect
            </h4>
          </Col>
        </Row>

        {/* Agent Info Section with QR Code */}
        <Row className="mb-4">
          <Col lg={10} md={9} sm={12}>
            <div style={{
              background: '#f8f9fa',
              padding: '2rem',
              borderRadius: '12px',
              border: '1px solid #e2e8f0'
            }}>
              <div className="mb-3">
                <div className="d-flex align-items-center mb-2">
                  <strong style={{ 
                    fontSize: '0.95rem', 
                    color: '#1e293b',
                    minWidth: '120px',
                    fontWeight: '600'
                  }}>
                    Agent Name
                  </strong>
                  <span style={{ 
                    fontSize: '1rem', 
                    color: '#1e293b',
                    fontWeight: '500'
                  }}>
                    {retailerInfo.agentName}
                  </span>
                </div>
              </div>

              <div className="mb-3">
                <div className="d-flex align-items-center mb-2">
                  <strong style={{ 
                    fontSize: '0.95rem', 
                    color: '#1e293b',
                    minWidth: '120px',
                    fontWeight: '600'
                  }}>
                    Contact
                  </strong>
                  <span style={{ 
                    fontSize: '1rem', 
                    color: '#1e293b',
                    fontWeight: '500'
                  }}>
                    {retailerInfo.contact}
                  </span>
                </div>
              </div>

              <div className="mb-3">
                <div className="d-flex align-items-center mb-2">
                  <strong style={{ 
                    fontSize: '0.95rem', 
                    color: '#1e293b',
                    minWidth: '120px',
                    fontWeight: '600'
                  }}>
                    UPI ID
                  </strong>
                  <span style={{ 
                    fontSize: '1rem', 
                    color: '#dc3545',
                    fontWeight: '500'
                  }}>
                    contact administrator
                  </span>
                </div>
              </div>

              <div className="mt-4">
                <Button 
                  onClick={handleDownloadQR}
                  style={{
                    padding: '0.5rem 1.5rem',
                    fontWeight: '600',
                    background: 'transparent',
                    border: '2px solid #667eea',
                    color: '#667eea',
                    borderRadius: '8px',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = '#667eea';
                    e.currentTarget.style.color = 'white';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'transparent';
                    e.currentTarget.style.color = '#667eea';
                  }}
                >
                  Download QR Code
                </Button>
              </div>
            </div>
          </Col>

          <Col lg={2} md={3} sm={12} className="d-flex align-items-center justify-content-center">
            <div style={{
              background: 'white',
              padding: '1rem',
              borderRadius: '12px',
              border: '2px solid #e2e8f0',
              boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
            }}>
              <img 
                src="/logo.png" 
                alt="QR Code" 
                style={{
                  width: '150px',
                  height: '150px',
                  objectFit: 'contain'
                }}
                onError={(e) => {
                  // Fallback if image not found - show placeholder
                  e.target.style.display = 'none';
                  e.target.parentElement.innerHTML = `
                    <div style="
                      width: 150px; 
                      height: 150px; 
                      display: flex; 
                      align-items: center; 
                      justify-content: center;
                      background: #f0f2f5;
                      border-radius: 8px;
                      color: #94a3b8;
                      font-size: 0.85rem;
                      text-align: center;
                      padding: 1rem;
                    ">
                      <div>
                        <i class="bi bi-qr-code" style="font-size: 3rem; display: block; margin-bottom: 0.5rem;"></i>
                        QR Code
                      </div>
                    </div>
                  `;
                }}
              />
            </div>
          </Col>
        </Row>

        {/* Table */}
        <div className="table-responsive" style={{ background: '#f0f2f5', borderRadius: '12px', padding: '0' }}>
          <Table bordered hover className="modern-table" style={{ background: '#f0f2f5' }}>
            <thead style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: 'white' }}>
              <tr>
                {columns.map((column) => (
                  <th key={column.key}>{column.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((row, index) => (
                  <tr key={index} style={{ background: '#f0f2f5' }}>
                    <td>{row.transactionDate}</td>
                    <td>{row.name}</td>
                    <td>{row.utr}</td>
                    <td>{row.upiHandle}</td>
                    <td><strong>₹{row.amount.toLocaleString()}</strong></td>
                    <td>
                      <Badge bg={getStatusVariant(row.status)}>
                        {row.status}
                      </Badge>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={columns.length} className="text-center py-4">
                    <i className="bi bi-inbox fs-1 text-muted d-block mb-2"></i>
                    <span className="text-muted">No collect requests found</span>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
    </Container>
  );
};

export default UPICollect;

